import { useMemo } from "react";

import { FRDClosureTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { FrdClosureFormProps } from "@/types/form-types";

import { useFrdUiSchema } from "../../schema/frd-ui-schema";

import { getFrdClosureSchema } from "./schema/frd-closure-schema";

export function FrdClosureForm(props: FrdClosureFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { formData, handleChange } = useBrostarFormDataStorage<FRDClosureTask>({
    key: "frdClosure",
    task,
  });

  const uiSchema = useFrdUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getFrdClosureSchema(type), [type]);

  const onSubmit = async () => {
    if (!formData) return;
    await api.createFrdClosure(formData);
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
